import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, CloseIcon } from '@paypalcorp/pp-react'

export default function CloseButton({ onClick = () => {}, ariaLabel = '', disabled = false }) {
  return (
    <div data-testid="close-button" className="ppvx_modal-header__close">
      <IconButton
        buttonType="tertiary"
        svgIconComponent={CloseIcon}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    </div>
  )
}

CloseButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
}
